import React from "react";
import PropTypes from "prop-types";
import { Tabs } from "rsuite";
import PropertyActiveIcon from "../../assets/img/property-active.png";
import PropertyInactiveIcon from "../../assets/img/property-inactive.png";
import { getHotelIdForPropertyId } from "../../pages/price-check/utils";

const PriceCheckTabs = ({
  activeTab,
  setActiveTab,
  properties,
  selectedCity,
  selectedProperties,
  onTabChange,
  searchBasedPropertyObjects = [],
}) => {
  // Only use search-based property objects - no fallback to form values
  // Ensure selectedPropertyObjects is always an array to prevent map errors
  const selectedPropertyObjects = searchBasedPropertyObjects || [];

  // Handle tab change with API call for specific hotel ID
  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);

    // Get hotel ID for the selected tab (tabKey is now propertyId)
    const hotelId = getHotelIdForPropertyId(properties, tabKey);

    // Call the API with the specific hotel ID or all hotel IDs for "all" tab
    if (onTabChange) {
      onTabChange(tabKey, hotelId);
    }
  };

  return (
    <Tabs activeKey={activeTab} onSelect={handleTabChange}>
      <Tabs.Tab
        eventKey="all"
        title={
          <span className="tabs-title">
            <img
              src={
                activeTab === "all" ? PropertyActiveIcon : PropertyInactiveIcon
              }
              alt="property icon"
              className="tabs-title-icon"
            />
            <span className="tabs-title-text">All properties</span>
          </span>
        }
      />
      {selectedPropertyObjects.map((propertyObj) => {
        const propertyId = propertyObj?.propertyId ?? propertyObj?.propertyName;
        const propertyName = propertyObj?.propertyName ?? propertyId;
        return (
          <Tabs.Tab
            eventKey={propertyId}
            key={propertyId}
            title={
              <span className="tabs-title">
                <img
                  src={
                    activeTab === propertyId
                      ? PropertyActiveIcon
                      : PropertyInactiveIcon
                  }
                  alt="property icon"
                  className="tabs-title-icon"
                />
                <span className="tabs-title-text">{propertyName}</span>
              </span>
            }
          />
        );
      })}
    </Tabs>
  );
};

PriceCheckTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  properties: PropTypes.arrayOf(
    PropTypes.shape({
      propertyId: PropTypes.string.isRequired,
      propertyName: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      expediaHotelId: PropTypes.string,
    })
  ).isRequired,
  selectedCity: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedProperties: PropTypes.arrayOf(PropTypes.string).isRequired,
  onTabChange: PropTypes.func,
  searchBasedPropertyObjects: PropTypes.arrayOf(
    PropTypes.shape({
      propertyId: PropTypes.string.isRequired,
      propertyName: PropTypes.string.isRequired,
    })
  ),
};

export default PriceCheckTabs;
